import React from "react";


import axios from "axios";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { TwButton } from "../../components/tailwind";
import { useLocalStorage } from "../../hooks";
import { loadingState, setGlobalLoading } from "../../redux/reducers/loadingReducer";
import { userState } from "../../redux/reducers/userReducer";
import { getUrlForBookings, getUrlForUsers } from "../../utils/confighelpers";

export default function BusinessProfileUpSubscriptionSuccess({ navigation }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const [userToken] = useLocalStorage("userToken");
  const userReduxState = useSelector(userState);
  const [searchParams, setSearchParams] = useSearchParams();
  const [subscriptionPlan, setSubscriptionPlan] = React.useState([]);
  const initialTime = moment();

  const getUserInfo = async () => {
    dispatch(setGlobalLoading(true));
    const config = {
      method: "get",
      url: `${getUrlForUsers()}getUserInfo`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const request = await axios(config);
    if (request.data.statusCode === 200) {
      console.log("data", request.data.data);
      const userData = request.data.data;

      /* if (userData.onBoardingStep === 0) {
      } else if (userData.onBoardingStep === 1) {
      } else if (userData.onBoardingStep === 2) {

      } else  */if (userData.onBoardingStep === 1) {
        navigation("/on-bording");
      } else if (userData.onBoardingStep === 3) {
        navigation("/businessprofilesetup/done");
      } else {
        var duration = moment.duration(moment(initialTime, 'YYYY-MM-DD h:mm A').diff(moment()));
        var minutes = duration.asMinutes();
        console.log("minutes", minutes);

        if (minutes <= 5) {
          var timer = setTimeout(async function () {
            await getUserInfo();
            // clearInterval(timer);
            // clearInterval(timeInterval);
          }, 5000);
        } else {
          dispatch(setGlobalLoading(false));
        }
      }
    }
  }

  const checkStripeSubscriptionCheckoutStatus = async () => {
    dispatch(setGlobalLoading(true));
    const config = {
      method: "post",
      url: `${getUrlForBookings()}payments/checkStripeSubscriptionCheckoutStatus`,
      data: {
        session_id: searchParams.get("session_id"),
        customer_id: searchParams.get("customer_id")
      },
      headers: {
        "x-access-token": userToken,
      },
    };
    const request = await axios(config);
    if (request.data.statusCode === 200) {
      console.log("data", request.data.data);
      const checkoutStatusData = request.data.data;

      if (checkoutStatusData.checkoutSessionStatus === "trialing" || checkoutStatusData.checkoutSessionStatus === "active") {
        if (userReduxState.businessType === "service") {
          navigation("/myresource/add", {
            state: {
              ...location.state,
              ...userReduxState.userData,
              from: "registration",
              sentFromVerifyEmail: true,
            },
          })
        } else {
          navigation("/businessprofilesetup/done");
        }
      } /* else if (checkoutStatusData.checkoutSessionStatus === "active") {
        navigation("/businessprofilesetup/done");
      }  */else {
        var duration = moment.duration(moment(initialTime, 'YYYY-MM-DD h:mm A').diff(moment()));
        var minutes = duration.asMinutes();
        console.log("minutes", minutes);

        if (minutes <= 5) {
          var timer = setTimeout(async function () {
            await checkStripeSubscriptionCheckoutStatus();
            // clearInterval(timer);
            // clearInterval(timeInterval);
          }, 5000);
        } else {
          dispatch(setGlobalLoading(false));
        }
      }
    }
  }

  React.useEffect(() => {
    dispatch(setGlobalLoading(true));
    setTimeout(async function () {
      if (userReduxState.businessType === "event") {
        await getUserInfo();
      } else {
        await checkStripeSubscriptionCheckoutStatus();
      }
    }, 2000);
  }, []);

  return (
    <div className="min-w-[1024px]">

      <div className={"px-4 mx-32 lg:mx-28 sm:mx-0 md:mx-4"}>
        <div
          id="subscriptionPlans"
          className="flex flex-col items-center justify-center gap-5 pt-5">
          {loadingReduxState.globalLoading === false && (<TwButton
            variant={"orange"}
            onClick={() => {
              // updateUserSubscription(d._id);
            }}>
            Back To Home
          </TwButton>)}
        </div>
      </div>
    </div>
  );
}
